import { usePLIPromoCookieInternalOrigin } from '@/hooks/usePLIPromoCookie';

export const PLIPromoTracker = () => {
  usePLIPromoCookieInternalOrigin();
  return <></>;
};
